// extracted by mini-css-extract-plugin
export default {"container":"ReturnBackButton_container__bCA4k"};